<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconLucide from '../icons/IconLucide.vue'

export default defineComponent({
  name: 'NavMenu',
  components: { IconLucide },
  setup() {
    const menus = ref([
      { name: 'home', title: 'Home', icon: 'Home' },
      { name: 'invoice', title: 'Invoice', icon: 'ReceiptText' },
      { name: 'profile', title: 'Profile', icon: 'CircleUserRound' },
    ])
    return { menus }
  },
})
</script>

<template>
  <ul class="menu w-full gap-1">
    <li v-for="(item, index) in menus" :key="index">
      <router-link :to="{ name: item.name }" active-class="menu-active">
        <IconLucide :name="item.icon" class="h-5 w-5" />
        {{ item.title }}
      </router-link>
    </li>
  </ul>
</template>

<style></style>
